export const MAIN_CLASS_NAME = 'ib-main-menu';
export const MOBILE_CLASS_NAME = `${MAIN_CLASS_NAME}_mobile`;
export const GROUP_CLASS_NAME = `${MAIN_CLASS_NAME}__group`;
export const DIVIDER_CLASS_NAME = `${MAIN_CLASS_NAME}__divider`;
